/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './styles.css';
import logo from '@assets/images/logo.png';

import { useDispatch, useSelector } from 'react-redux';
import { ComboBox, Button } from '@components';
import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { searchValues } from '@utils';
import { mdiMagnify } from '@mdi/js';
import { alterarPlanoOuUsuarioRequest } from '../../../store/modules/user/actions';

import { Relogio } from '../Relogio';
import { useAuth } from '../../../pages/Shell';
import { HOME } from '../../utils/paths';
import Icons from '../Icon';

const CustomizedAutocomplete = styled((props) => (
  <Autocomplete {...props} inputMode="search" />
))`
  .MuiOutlinedInput-notchedOutline {
    border-color: var(--primary-color);
    border-radius: 25px;
  }
`;

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useAuth();
  const user = useSelector((state) => state.user);
  const custom = useSelector((state) => state.customizaSistema);
  const telasDisponiveis = useSelector((state) => state.telasDisponiveis);
  const [modoSimulacao, setModoSimulacao] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('0');
  const [search, setSearch] = useState('');

  const filteredOptions = searchValues.filter((option) => {
    const alwaysShow = option.id.length === 0;
    const screenEnabled = option.id.some((id) => telasDisponiveis[id]);

    return alwaysShow || screenEnabled;
  });

  const alteraValoresStore = useCallback(
    (plan) => {
      dispatch(
        alterarPlanoOuUsuarioRequest({
          id: localStorage.getItem('Id'),
          matricula: localStorage.getItem('Matricula'),
          token: localStorage.getItem('Token'),
          plano: plan,
        })
      );
    },
    [dispatch]
  );

  const logout = () => {
    auth.signout();
  };

  useEffect(() => {
    if (user.plano !== '' && user.plano !== undefined) {
      setSelectedPlan(
        user.listaPlanos.find((plan) => plan.value === user.plano).value
      );
    }
  }, [user.plano, user.listaPlanos]);

  useEffect(() => {
    if (user.id && user.matricula) {
      if (user.matricula !== user.id) {
        setModoSimulacao(true);
      } else {
        setModoSimulacao(false);
      }
    }
    if (!localStorage.getItem('Id')) {
      auth.signout();
    }
  }, [user.id, user.matricula, auth]);

  return (
    <>
      {modoSimulacao && (
        <div className="topHeader">
          <h4>FORLUZ : FORLUZ : FORLUZ : FORLUZ : FORLUZ : FORLUZ</h4>
        </div>
      )}
      <div className="header mb-32">
        <div data-tour="step-0">
          <Link to={HOME}>
            <img className="logo" src={logo} alt="Forluz logo" />
          </Link>
          <div className="relogio">
            <div className="d-none d-lg-flex align-items-center">
              <Relogio />
            </div>
          </div>
        </div>
        <div
          className="d-none d-lg-flex align-items-center gap-3"
          data-tour="step-1"
        >
          {user.listaPlanos.length > 0 && (
            <ComboBox
              color={custom.nomeCorPrincipal}
              options={user.listaPlanos.map((x) => {
                return { value: x.value, label: x.label };
              })}
              value={selectedPlan}
              onChange={(value) => {
                alteraValoresStore(value);
                setSelectedPlan(value);
              }}
            />
          )}
          <CustomizedAutocomplete
            size="small"
            freeSolo
            options={filteredOptions.map((option) => option.title)}
            onChange={(e, value) => {
              const route = filteredOptions.find(
                (op) => op.title === value
              )?.path;

              if (route) {
                navigate(route);
              }
            }}
            onInputChange={(e, value) => setSearch(value)}
            className="w-250"
            renderInput={(params) => (
              <TextField
                {...params}
                label="O que você procura?"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icons path={mdiMagnify} color="#727272" />
                    </InputAdornment>
                  ),
                }}
              />
            )}
            value={search}
          />
        </div>
        <div className="d-none d-lg-flex align-items-center">
          <Button
            className="force-orange-color"
            onClick={() => {
              navigate(HOME);
            }}
          >
            {`${user.matricula} - ${user.nome}`}
          </Button>
          {/* <Notifications /> */}
        </div>
        <div className="d-flex d-lg-none">
          {user.listaPlanos.length > 0 && (
            <ComboBox
              color={custom.nomeCorPrincipal}
              options={user.listaPlanos.map((x) => {
                return { value: x.value, label: x.label };
              })}
              value={selectedPlan}
              onChange={(value) => {
                alteraValoresStore(value);
                setSelectedPlan(value);
              }}
            />
          )}
          <Button
            className="only-icon ms-3"
            transparent
            color="orange"
            icon="search"
          />
          <Button
            className="only-icon ms-3"
            transparent
            color="muted"
            icon="clear"
            onClick={() => logout()}
          />
        </div>
      </div>
    </>
  );
};
